<template>

    <div class="product-add" v-loading="loading">
      <!--form表单-->
      <el-form size="small" ref="form" :model="form"  label-width="150px" v-if="!loading">
        <!--添加门店-->
        <div class="common-form">设置</div>
        <el-form-item label="是否开启更新经纬度：">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="查询间隔" prop="interval" :rules="[{required: true,message: ' '}]">
          <el-input v-model="form.interval" type="number" min=10 class="max-w460"></el-input>
          秒
        </el-form-item>
        <el-form-item label="每次更新数量" prop="num" :rules="[{required: true,message: ' '}]">
          <el-input v-model="form.num" type="number" min=10 class="max-w460"></el-input>条
        </el-form-item>
        <el-form-item label="限制查询时间" prop="querytime" :rules="[{required: true,message: ' '}]">
          <el-input v-model="form.querytime" type="number" min=1 class="max-w460"></el-input>小时
          <div>最低每隔多少小时更新一次数据</div>
        </el-form-item>
        
        <div class="common-form">高德相关</div>
        <el-form-item label="地址编码剩余" >
            
            <el-input v-model="form.use_inverse_geocoding_num" :disabled="true" class="max-w460"></el-input>
          <div>剩余配额不会每日自动更新，具体设置请前往<a href="#/setting/store/index">【设置】</a> </div>
        </el-form-item>

      
        
        <!--提交-->
        <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
    </div>
  
  </template>
  
  <script>
    import StoreApi from '@/api/store.js';
    import { formatModel } from '@/utils/base.js';
    export default {
      components:{},
      data() {
        return {
          /*是否正在加载*/
          loading: true,
          /*form表单数据
          */
          form: {
            interval: 10,//查询间隔 1  代表1秒
            status:0,//状态 0 关闭 1 开启
            num:10,//数量 每次查询的数量 即更新数量
            querytime:1,//限制查询时间 小时为单位
            gd_key:"",
            gd_secret:"",
            inverse_geocoding_num:0,
            use_inverse_geocoding_num:0,

          },
  
        };
      },
      created() {
        this.getParams()
      },
  
      methods: {
  
        /*获取配置数据*/
        getParams() {
          let self = this;
          StoreApi.getSetting({}, true)
            .then(res => {
              let vars = res.data.vars.values;
              self.form = formatModel(self.form, vars);
              self.loading=false;
            })
            .catch(error => {
              self.loading=false;
            });
        },
  
        /*提交*/
        onSubmit() {
          let self = this;
          let params = this.form;
          self.$refs.form.validate((valid) => {
            if (valid) {
              self.loading = true;
              StoreApi.saveSetting(params, true)
                .then(data => {
                  self.loading = false;
                  self.$message({
                    message: '恭喜你，设置成功',
                    type: 'success'
                  });
                })
                .catch(error => {
                  self.loading = false;
                });
            }
          });
        },
        //监听复选框选中
        handleCheckedGetLog(e) {
  
        },
      }
  
    };
  </script>
  <style>
    .tips {
      color: #ccc;
    }
  </style>
  


// WEBPACK FOOTER //
// src/views/store/store/setting.vue